import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar/Navbar';
import './ForgotPasswordPage.css';

const API_AUTH_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const ForgotPasswordPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${API_AUTH_URL}/forgot-password`, { email });
            toast.success(response.data.message || t('forgot_password_success', 'Se o e-mail estiver cadastrado, um código foi enviado.'));
            // Redirect to reset page after a short delay
            setTimeout(() => {
                navigate('/reset-password', { state: { email } });
            }, 2000);
        } catch (err) {
            toast.error(err.response?.data?.message || t('forgot_password_error', 'Erro ao solicitar recuperação.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-page">
            <Navbar />
            <div className="forgot-password-container">
                <div className="forgot-password-card">
                    <div className="forgot-password-header">
                        <h2>{t('forgot_password_title', 'Recuperar Senha')}</h2>
                        <p>{t('forgot_password_subtitle', 'Insira seu e-mail para receber o código de recuperação.')}</p>
                    </div>

                    <form onSubmit={handleSubmit} className="forgot-password-form">
                        <div className="input-group">
                            <label>{t('email', 'E-mail')}</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="exemplo@email.com"
                                required
                            />
                        </div>

                        <button type="submit" className="forgot-password-btn" disabled={loading}>
                            {loading ? t('loading', 'Enviando...') : t('send_code', 'Enviar Código')}
                        </button>
                    </form>

                    <div className="forgot-password-footer">
                        <Link to="/login" className="back-to-login">
                            {t('back_to_login', 'Voltar para o Login')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
